module.exports = {
  deleted: 'deleted',
  temporaryDeactivation: 'temporary-deactivation'
};
